import React from 'react';
import './index.css';
import "../../App.css";
import '../../views/Lore/styles.css';

// import "../../views/FounderPacks/styles.css";

import { POSTS } from 'src/utils/constants/blogposts';

const BlogPostPreview = React.lazy(() => import('src/components/BlogPostPreview'));
const BlogPostFooter = React.lazy(() => import('src/components/BlogPostFooter'));


const Blog = () => {
    let orderedPosts = POSTS.sort(function(first, second) {
        return second.order - first.order;
    })
    return <div className="App">
        <div className='blogpage'>
            <div id='bp-title'>
                <h1>Aether TCG Blog</h1>
                <p>Read recent stories about Aether TCG accomplishments, partnerships, expansions and gameplay features.</p>
            </div>
            <div className="bp-content">
                    <div id='list-of-posts'>
                        {orderedPosts.map((post) => <>
                            <BlogPostPreview post={post} />
                        </>)}
                    </div>
            </div>
            <BlogPostFooter />
        </div>
    </div>
};

export default Blog;